/**
 * Wave 36 — Phase 2 country SEO expansion
 * Expands USA, UAE, Saudi Arabia, Canada, Italy, Portugal, Netherlands to full 15-language coverage
 */
import type { CountrySEOMap } from './country-seo-i18n-types';

export const COUNTRY_SEO_I18N_WAVE36: CountrySEOMap = {

  // ============ USA — expand from 4 to 15 languages ============
  usa: {
    it: {
      title: 'Call Center USA | Assistenza Clienti in Inglese 24/7 | Call IT Dev',
      description: 'Call center per gli USA: agenti anglofoni, copertura 24/7, CSAT 95%, da 3 $/h. 70% risparmio vs New York.',
      heroTitle: 'Call Center per gli USA — Supporto Anglofono 24/7',
      heroSubtitle: 'Assistenza clienti premium per il mercato americano. 70% in meno rispetto a New York.',
    },
    pt: {
      title: 'Call Center EUA | Atendimento ao Cliente 24/7 | Call IT Dev',
      description: 'Call center para EUA: agentes anglófonos, cobertura 24/7, CSAT 95%, a partir de 3 $/h. 70% economia vs Nova York.',
      heroTitle: 'Call Center para os EUA — Suporte Anglófono 24/7',
      heroSubtitle: 'Atendimento premium para o mercado americano. 70% mais barato que Nova York.',
    },
    nl: {
      title: 'Callcenter VS | Engelstalige Klantenservice 24/7 | Call IT Dev',
      description: 'Callcenter voor de VS: Engelstalige agenten, 24/7 dekking, CSAT 95%, vanaf 3 $/u. 70% besparing vs New York.',
      heroTitle: 'Callcenter voor de VS — Engelstalige Support 24/7',
      heroSubtitle: 'Premium klantenservice voor de Amerikaanse markt. 70% goedkoper dan New York.',
    },
    pl: {
      title: 'Call Center USA | Obsługa Klienta 24/7 | Call IT Dev',
      description: 'Call center dla USA: anglojęzyczni agenci, pokrycie 24/7, CSAT 95%, od 3 $/h. 70% oszczędności vs Nowy Jork.',
      heroTitle: 'Call Center dla USA — Anglojęzyczne Wsparcie 24/7',
      heroSubtitle: 'Premiumowa obsługa klienta dla rynku amerykańskiego. 70% taniej niż Nowy Jork.',
    },
    tr: {
      title: 'ABD Çağrı Merkezi | Müşteri Hizmetleri 24/7 | Call IT Dev',
      description: 'ABD için çağrı merkezi: İngilizce konuşan ajanlar, 24/7 kapsam, CSAT %95, 3 $/saatten. New York\'a göre %70 tasarruf.',
      heroTitle: 'ABD İçin Çağrı Merkezi — İngilizce Destek 24/7',
      heroSubtitle: 'Amerikan pazarı için premium müşteri hizmeti. New York\'tan %70 daha ucuz.',
    },
    sv: {
      title: 'Callcenter USA | Engelskspråkig Kundtjänst 24/7 | Call IT Dev',
      description: 'Callcenter för USA: engelskspråkiga agenter, 24/7 täckning, CSAT 95%, från 3 $/h. 70% besparing vs New York.',
      heroTitle: 'Callcenter för USA — Engelskspråkig Kundtjänst 24/7',
      heroSubtitle: 'Premium kundtjänst för den amerikanska marknaden. 70% billigare än New York.',
    },
    da: {
      title: 'Callcenter USA | Engelsksproget Kundeservice 24/7 | Call IT Dev',
      description: 'Callcenter for USA: engelsksproget agenter, 24/7 dækning, CSAT 95%, fra 3 $/t. 70% besparelse vs New York.',
      heroTitle: 'Callcenter for USA — Engelsksproget Kundeservice 24/7',
      heroSubtitle: 'Premium kundeservice for det amerikanske marked. 70% billigere end New York.',
    },
    zh: {
      title: '美国呼叫中心 | 英语客服外包 24/7 | Call IT Dev',
      description: '美国呼叫中心外包：英语母语座席，24/7覆盖，CSAT 95%，3美元/小时起。比纽约节省70%。',
      heroTitle: '美国呼叫中心 — 英语客服支持 24/7',
      heroSubtitle: '为美国市场提供优质客户服务。比纽约运营成本低70%。',
    },
    ja: {
      title: 'アメリカコールセンター | 英語カスタマーサポート 24/7 | Call IT Dev',
      description: 'アメリカ向けコールセンター：英語ネイティブ、24/7対応、CSAT 95%、3$/時間〜。ニューヨーク比70%削減。',
      heroTitle: 'アメリカ向けコールセンター — 英語サポート 24/7',
      heroSubtitle: 'アメリカ市場向けプレミアムカスタマーサービス。ニューヨークの70%低コスト。',
    },
    ko: {
      title: '미국 콜센터 | 영어 고객 서비스 24/7 | Call IT Dev',
      description: '미국 콜센터: 영어 원어민 상담원, 24/7 커버리지, CSAT 95%, 시간당 3달러부터. 뉴욕 대비 70% 절감.',
      heroTitle: '미국 콜센터 — 영어 고객 지원 24/7',
      heroSubtitle: '미국 시장을 위한 프리미엄 고객 서비스. 뉴욕보다 70% 저렴.',
    },
    ru: {
      title: 'Колл-центр США | Англоязычный сервис 24/7 | Call IT Dev',
      description: 'Колл-центр для США: англоязычные агенты, покрытие 24/7, CSAT 95%, от 3 $/ч. Экономия 70% vs Нью-Йорк.',
      heroTitle: 'Колл-центр для США — Англоязычная поддержка 24/7',
      heroSubtitle: 'Премиум-обслуживание для американского рынка. На 70% дешевле Нью-Йорка.',
    },
  },

  // ============ UAE — expand from 4 to 15 languages ============
  uae: {
    it: {
      title: 'Call Center EAU Dubai | Assistenza Clienti Multilingue | Call IT Dev',
      description: 'Call center per EAU: agenti arabofoni e anglofoni, CSAT 95%, da 3 $/h. Supporto multilingue 24/7.',
      heroTitle: 'Call Center per gli EAU — Supporto Multilingue da Casablanca',
      heroSubtitle: 'Assistenza clienti premium in arabo e inglese per il mercato emiratino.',
    },
    pt: {
      title: 'Call Center EAU Dubai | Atendimento Multilingue | Call IT Dev',
      description: 'Call center para EAU: agentes árabe e inglês, CSAT 95%, a partir de 3 $/h. Suporte multilingue 24/7.',
      heroTitle: 'Call Center para os EAU — Suporte Multilingue de Casablanca',
      heroSubtitle: 'Atendimento premium em árabe e inglês para o mercado emiratino.',
    },
    nl: {
      title: 'Callcenter VAE Dubai | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor VAE: Arabisch- en Engelstalige agenten, CSAT 95%, vanaf 3 $/u. 24/7 meertalig.',
      heroTitle: 'Callcenter voor de VAE — Meertalige Support vanuit Casablanca',
      heroSubtitle: 'Premium klantenservice in het Arabisch en Engels voor de Emiraten.',
    },
    pl: {
      title: 'Call Center ZEA Dubaj | Wielojęzyczna Obsługa Klienta | Call IT Dev',
      description: 'Call center dla ZEA: agenci arabsko- i anglojęzyczni, CSAT 95%, od 3 $/h. Wsparcie 24/7.',
      heroTitle: 'Call Center dla ZEA — Wielojęzyczne Wsparcie z Casablanki',
      heroSubtitle: 'Premiumowa obsługa klienta w arabskim i angielskim dla rynku emirackiego.',
    },
    tr: {
      title: 'BAE Dubai Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'BAE için çağrı merkezi: Arapça ve İngilizce konuşan ajanlar, CSAT %95, 3 $/saatten. 24/7 destek.',
      heroTitle: 'BAE İçin Çağrı Merkezi — Kazablanka\'dan Çok Dilli Destek',
      heroSubtitle: 'Emirat pazarı için Arapça ve İngilizce premium müşteri hizmeti.',
    },
    sv: {
      title: 'Callcenter FAE Dubai | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för FAE: arabisk- och engelskspråkiga agenter, CSAT 95%, från 3 $/h. 24/7.',
      heroTitle: 'Callcenter för FAE — Flerspråkig Kundtjänst från Casablanca',
      heroSubtitle: 'Premium kundtjänst på arabiska och engelska för emiratmarknaden.',
    },
    da: {
      title: 'Callcenter FAE Dubai | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter for FAE: arabisk- og engelsksproget agenter, CSAT 95%, fra 3 $/t. 24/7.',
      heroTitle: 'Callcenter for FAE — Flersproget Kundeservice fra Casablanca',
      heroSubtitle: 'Premium kundeservice på arabisk og engelsk for det emiratiske marked.',
    },
    zh: {
      title: '阿联酋迪拜呼叫中心 | 多语言客服 | Call IT Dev',
      description: '阿联酋呼叫中心：阿拉伯语和英语座席，CSAT 95%，3美元/小时起。24/7多语言支持。',
      heroTitle: '阿联酋呼叫中心 — 卡萨布兰卡多语言支持',
      heroSubtitle: '为阿联酋市场提供阿拉伯语和英语优质客户服务。',
    },
    ja: {
      title: 'UAEドバイコールセンター | 多言語カスタマーサポート | Call IT Dev',
      description: 'UAE向けコールセンター：アラビア語・英語対応、CSAT 95%、3$/時間〜。24/7多言語サポート。',
      heroTitle: 'UAE向けコールセンター — カサブランカからの多言語サポート',
      heroSubtitle: 'UAE市場向けアラビア語・英語プレミアムカスタマーサービス。',
    },
    ko: {
      title: 'UAE 두바이 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: 'UAE 콜센터: 아랍어·영어 상담원, CSAT 95%, 시간당 3달러부터. 24/7 다국어 지원.',
      heroTitle: 'UAE 콜센터 — 카사블랑카에서 다국어 지원',
      heroSubtitle: 'UAE 시장을 위한 아랍어·영어 프리미엄 고객 서비스.',
    },
    ru: {
      title: 'Колл-центр ОАЭ Дубай | Многоязычный сервис | Call IT Dev',
      description: 'Колл-центр для ОАЭ: арабо- и англоязычные агенты, CSAT 95%, от 3 $/ч. 24/7 поддержка.',
      heroTitle: 'Колл-центр для ОАЭ — Многоязычная поддержка из Касабланки',
      heroSubtitle: 'Премиум-обслуживание на арабском и английском для рынка Эмиратов.',
    },
  },

  // ============ SAUDI ARABIA — expand from 2 to 15 languages ============
  'saudi-arabia': {
    es: {
      title: 'Call Center Arabia Saudita | Atención al Cliente Árabe 24/7 | Call IT Dev',
      description: 'Call center para Arabia Saudita: agentes árabes nativos, CSAT 95%, desde 3 $/h. Compatible con Visión 2030.',
      heroTitle: 'Call Center para Arabia Saudita — Soporte Árabe Nativo',
      heroSubtitle: 'Atención al cliente premium en árabe para el mercado saudí. Visión 2030.',
    },
    de: {
      title: 'Call Center Saudi-Arabien | Arabischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Saudi-Arabien: arabische Muttersprachler, CSAT 95%, ab 3 $/h. Vision 2030-kompatibel.',
      heroTitle: 'Call Center für Saudi-Arabien — Arabischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice auf Arabisch für den saudischen Markt.',
    },
    it: {
      title: 'Call Center Arabia Saudita | Assistenza Clienti in Arabo | Call IT Dev',
      description: 'Call center per l\'Arabia Saudita: agenti arabofoni nativi, CSAT 95%, da 3 $/h. Compatibile Vision 2030.',
      heroTitle: 'Call Center per l\'Arabia Saudita — Supporto Arabo Nativo',
      heroSubtitle: 'Assistenza clienti premium in arabo per il mercato saudita.',
    },
    pt: {
      title: 'Call Center Arábia Saudita | Atendimento em Árabe 24/7 | Call IT Dev',
      description: 'Call center para Arábia Saudita: agentes árabes nativos, CSAT 95%, a partir de 3 $/h. Visão 2030.',
      heroTitle: 'Call Center para Arábia Saudita — Suporte Árabe Nativo',
      heroSubtitle: 'Atendimento premium em árabe para o mercado saudita.',
    },
    nl: {
      title: 'Callcenter Saoedi-Arabië | Arabischtalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Saoedi-Arabië: Arabische moedertaalsprekers, CSAT 95%, vanaf 3 $/u. Visie 2030.',
      heroTitle: 'Callcenter voor Saoedi-Arabië — Arabischtalige Support',
      heroSubtitle: 'Premium klantenservice in het Arabisch voor de Saoedische markt.',
    },
    pl: {
      title: 'Call Center Arabia Saudyjska | Obsługa Klienta po Arabsku | Call IT Dev',
      description: 'Call center dla Arabii Saudyjskiej: arabskojęzyczni agenci, CSAT 95%, od 3 $/h. Wizja 2030.',
      heroTitle: 'Call Center dla Arabii Saudyjskiej — Arabskojęzyczne Wsparcie',
      heroSubtitle: 'Premiumowa obsługa klienta po arabsku dla rynku saudyjskiego.',
    },
    tr: {
      title: 'Suudi Arabistan Çağrı Merkezi | Arapça Müşteri Hizmetleri | Call IT Dev',
      description: 'Suudi Arabistan için çağrı merkezi: anadil Arapça konuşanlar, CSAT %95, 3 $/saatten. Vizyon 2030.',
      heroTitle: 'Suudi Arabistan İçin Çağrı Merkezi — Arapça Destek',
      heroSubtitle: 'Suudi pazarı için Arapça premium müşteri hizmeti.',
    },
    sv: {
      title: 'Callcenter Saudiarabien | Arabiskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Saudiarabien: arabiskspråkiga agenter, CSAT 95%, från 3 $/h. Vision 2030.',
      heroTitle: 'Callcenter för Saudiarabien — Arabiskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst på arabiska för den saudiska marknaden.',
    },
    da: {
      title: 'Callcenter Saudi-Arabien | Arabisksproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Saudi-Arabien: arabisksproget agenter, CSAT 95%, fra 3 $/t. Vision 2030.',
      heroTitle: 'Callcenter for Saudi-Arabien — Arabisksproget Kundeservice',
      heroSubtitle: 'Premium kundeservice på arabisk for det saudiske marked.',
    },
    zh: {
      title: '沙特阿拉伯呼叫中心 | 阿拉伯语客服 24/7 | Call IT Dev',
      description: '沙特呼叫中心：阿拉伯语母语座席，CSAT 95%，3美元/小时起。兼容2030愿景。',
      heroTitle: '沙特阿拉伯呼叫中心 — 阿拉伯语母语支持',
      heroSubtitle: '为沙特市场提供阿拉伯语优质客户服务。',
    },
    ja: {
      title: 'サウジアラビアコールセンター | アラビア語サポート 24/7 | Call IT Dev',
      description: 'サウジアラビア向けコールセンター：アラビア語ネイティブ、CSAT 95%、3$/時間〜。ビジョン2030対応。',
      heroTitle: 'サウジアラビア向けコールセンター — アラビア語ネイティブサポート',
      heroSubtitle: 'サウジ市場向けアラビア語プレミアムカスタマーサービス。',
    },
    ko: {
      title: '사우디아라비아 콜센터 | 아랍어 고객 서비스 24/7 | Call IT Dev',
      description: '사우디 콜센터: 아랍어 원어민 상담원, CSAT 95%, 시간당 3달러부터. 비전 2030 호환.',
      heroTitle: '사우디아라비아 콜센터 — 아랍어 원어민 지원',
      heroSubtitle: '사우디 시장을 위한 아랍어 프리미엄 고객 서비스.',
    },
    ru: {
      title: 'Колл-центр Саудовская Аравия | Арабоязычный сервис 24/7 | Call IT Dev',
      description: 'Колл-центр для Саудовской Аравии: арабоязычные агенты, CSAT 95%, от 3 $/ч. Совместим с Vision 2030.',
      heroTitle: 'Колл-центр для Саудовской Аравии — Арабоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание на арабском для саудовского рынка.',
    },
  },

  // ============ CANADA — expand from 2 to 15 languages ============
  canada: {
    de: {
      title: 'Call Center Kanada | Zweisprachiger Kundenservice FR/EN | Call IT Dev',
      description: 'Call Center für Kanada: zweisprachige Agenten FR/EN, CSAT 95%, ab 3 $/h. 65% Ersparnis vs Montreal.',
      heroTitle: 'Call Center für Kanada — Zweisprachiger Support FR/EN',
      heroSubtitle: 'Premium zweisprachiger Kundenservice für den kanadischen Markt.',
    },
    ar: {
      title: 'مركز اتصال كندا | خدمة عملاء ثنائية اللغة FR/EN | Call IT Dev',
      description: 'مركز اتصال لكندا: وكلاء ثنائيو اللغة فرنسي/إنجليزي، CSAT 95%، من 3 $/ساعة. توفير 65%.',
      heroTitle: 'مركز اتصال لكندا — دعم ثنائي اللغة FR/EN',
      heroSubtitle: 'خدمة عملاء ثنائية اللغة للسوق الكندي.',
    },
    it: {
      title: 'Call Center Canada | Assistenza Bilingue FR/EN | Call IT Dev',
      description: 'Call center per il Canada: agenti bilingui FR/EN, CSAT 95%, da 3 $/h. 65% risparmio vs Montreal.',
      heroTitle: 'Call Center per il Canada — Supporto Bilingue FR/EN',
      heroSubtitle: 'Assistenza bilingue per il mercato canadese. 65% in meno rispetto a Montreal.',
    },
    pt: {
      title: 'Call Center Canadá | Atendimento Bilíngue FR/EN | Call IT Dev',
      description: 'Call center para Canadá: agentes bilíngues FR/EN, CSAT 95%, a partir de 3 $/h. 65% economia vs Montreal.',
      heroTitle: 'Call Center para Canadá — Suporte Bilíngue FR/EN',
      heroSubtitle: 'Atendimento bilíngue para o mercado canadense.',
    },
    nl: {
      title: 'Callcenter Canada | Tweetalige Klantenservice FR/EN | Call IT Dev',
      description: 'Callcenter voor Canada: tweetalige agenten FR/EN, CSAT 95%, vanaf 3 $/u. 65% besparing vs Montreal.',
      heroTitle: 'Callcenter voor Canada — Tweetalige Support FR/EN',
      heroSubtitle: 'Tweetalige klantenservice voor de Canadese markt.',
    },
    pl: {
      title: 'Call Center Kanada | Dwujęzyczna Obsługa FR/EN | Call IT Dev',
      description: 'Call center dla Kanady: dwujęzyczni agenci FR/EN, CSAT 95%, od 3 $/h. 65% oszczędności vs Montreal.',
      heroTitle: 'Call Center dla Kanady — Dwujęzyczne Wsparcie FR/EN',
      heroSubtitle: 'Dwujęzyczna obsługa klienta dla rynku kanadyjskiego.',
    },
    tr: {
      title: 'Kanada Çağrı Merkezi | İki Dilli Müşteri Hizmetleri FR/EN | Call IT Dev',
      description: 'Kanada için çağrı merkezi: iki dilli ajanlar FR/EN, CSAT %95, 3 $/saatten. Montreal\'e göre %65 tasarruf.',
      heroTitle: 'Kanada İçin Çağrı Merkezi — İki Dilli Destek FR/EN',
      heroSubtitle: 'Kanada pazarı için iki dilli müşteri hizmeti.',
    },
    sv: {
      title: 'Callcenter Kanada | Tvåspråkig Kundtjänst FR/EN | Call IT Dev',
      description: 'Callcenter för Kanada: tvåspråkiga agenter FR/EN, CSAT 95%, från 3 $/h. 65% besparing vs Montreal.',
      heroTitle: 'Callcenter för Kanada — Tvåspråkig Kundtjänst FR/EN',
      heroSubtitle: 'Tvåspråkig kundtjänst för den kanadensiska marknaden.',
    },
    da: {
      title: 'Callcenter Canada | Tosproget Kundeservice FR/EN | Call IT Dev',
      description: 'Callcenter for Canada: tosproget agenter FR/EN, CSAT 95%, fra 3 $/t. 65% besparelse vs Montreal.',
      heroTitle: 'Callcenter for Canada — Tosproget Kundeservice FR/EN',
      heroSubtitle: 'Tosproget kundeservice for det canadiske marked.',
    },
    zh: {
      title: '加拿大呼叫中心 | 双语客服 FR/EN | Call IT Dev',
      description: '加拿大呼叫中心：法英双语座席，CSAT 95%，3美元/小时起。比蒙特利尔节省65%。',
      heroTitle: '加拿大呼叫中心 — 法英双语支持',
      heroSubtitle: '为加拿大市场提供双语客户服务。',
    },
    ja: {
      title: 'カナダコールセンター | バイリンガルサポート FR/EN | Call IT Dev',
      description: 'カナダ向けコールセンター：仏英バイリンガル、CSAT 95%、3$/時間〜。モントリオール比65%削減。',
      heroTitle: 'カナダ向けコールセンター — バイリンガルサポート FR/EN',
      heroSubtitle: 'カナダ市場向けバイリンガルカスタマーサービス。',
    },
    ko: {
      title: '캐나다 콜센터 | 이중 언어 고객 서비스 FR/EN | Call IT Dev',
      description: '캐나다 콜센터: 불어/영어 이중 언어 상담원, CSAT 95%, 시간당 3달러부터. 몬트리올 대비 65% 절감.',
      heroTitle: '캐나다 콜센터 — 이중 언어 지원 FR/EN',
      heroSubtitle: '캐나다 시장을 위한 이중 언어 고객 서비스.',
    },
    ru: {
      title: 'Колл-центр Канада | Двуязычный сервис FR/EN | Call IT Dev',
      description: 'Колл-центр для Канады: двуязычные агенты FR/EN, CSAT 95%, от 3 $/ч. Экономия 65% vs Монреаль.',
      heroTitle: 'Колл-центр для Канады — Двуязычная поддержка FR/EN',
      heroSubtitle: 'Двуязычное обслуживание для канадского рынка.',
    },
  },

  // ============ ITALY — expand from 2 to 15 languages ============
  italy: {
    es: {
      title: 'Call Center Italia | Externalización Servicio al Cliente | Call IT Dev',
      description: 'Call center para Italia: agentes italófonos, CSAT 95%, desde 3 $/h. 55% ahorro vs Milán.',
      heroTitle: 'Call Center para Italia — Soporte Italófono',
      heroSubtitle: 'Atención al cliente premium en italiano. 55% más barato que Milán.',
    },
    de: {
      title: 'Call Center Italien | Italienischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Italien: italienische Muttersprachler, CSAT 95%, ab 3 $/h. 55% Ersparnis vs Mailand.',
      heroTitle: 'Call Center für Italien — Italienischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice auf Italienisch. 55% günstiger als Mailand.',
    },
    ar: {
      title: 'مركز اتصال إيطاليا | خدمة عملاء بالإيطالية | Call IT Dev',
      description: 'مركز اتصال لإيطاليا: وكلاء ناطقون بالإيطالية، CSAT 95%، من 3 $/ساعة. توفير 55% مقارنة بميلان.',
      heroTitle: 'مركز اتصال لإيطاليا — دعم بالإيطالية',
      heroSubtitle: 'خدمة عملاء متميزة بالإيطالية. أقل 55% من ميلان.',
    },
    pt: {
      title: 'Call Center Itália | Atendimento em Italiano | Call IT Dev',
      description: 'Call center para Itália: agentes italófonos, CSAT 95%, a partir de 3 $/h. 55% economia vs Milão.',
      heroTitle: 'Call Center para Itália — Suporte em Italiano',
      heroSubtitle: 'Atendimento premium em italiano. 55% mais barato que Milão.',
    },
    nl: {
      title: 'Callcenter Italië | Italiaanstalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Italië: Italiaanstalige agenten, CSAT 95%, vanaf 3 $/u. 55% besparing vs Milaan.',
      heroTitle: 'Callcenter voor Italië — Italiaanstalige Klantenservice',
      heroSubtitle: 'Premium klantenservice in het Italiaans. 55% goedkoper dan Milaan.',
    },
    pl: {
      title: 'Call Center Włochy | Obsługa Klienta po Włosku | Call IT Dev',
      description: 'Call center dla Włoch: włoskojęzyczni agenci, CSAT 95%, od 3 $/h. 55% oszczędności vs Mediolan.',
      heroTitle: 'Call Center dla Włoch — Włoskojęzyczna Obsługa',
      heroSubtitle: 'Premiumowa obsługa klienta po włosku. 55% taniej niż Mediolan.',
    },
    tr: {
      title: 'İtalya Çağrı Merkezi | İtalyanca Müşteri Hizmetleri | Call IT Dev',
      description: 'İtalya için çağrı merkezi: İtalyanca konuşan ajanlar, CSAT %95, 3 $/saatten. Milano\'ya göre %55 tasarruf.',
      heroTitle: 'İtalya İçin Çağrı Merkezi — İtalyanca Destek',
      heroSubtitle: 'Nearshore fiyatlarla İtalyanca premium müşteri hizmeti.',
    },
    sv: {
      title: 'Callcenter Italien | Italienskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Italien: italienskspråkiga agenter, CSAT 95%, från 3 $/h. 55% besparing vs Milano.',
      heroTitle: 'Callcenter för Italien — Italienskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst på italienska. 55% billigare än Milano.',
    },
    da: {
      title: 'Callcenter Italien | Italiensksproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Italien: italiensksproget agenter, CSAT 95%, fra 3 $/t. 55% besparelse vs Milano.',
      heroTitle: 'Callcenter for Italien — Italiensksproget Kundeservice',
      heroSubtitle: 'Premium kundeservice på italiensk. 55% billigere end Milano.',
    },
    zh: {
      title: '意大利呼叫中心 | 意大利语客服外包 | Call IT Dev',
      description: '意大利呼叫中心外包：意大利语母语座席，CSAT 95%，3美元/小时起。比米兰节省55%。',
      heroTitle: '意大利呼叫中心 — 意大利语母语支持',
      heroSubtitle: '以nearshore价格提供优质意大利语客户体验。',
    },
    ja: {
      title: 'イタリアコールセンター | イタリア語カスタマーサポート | Call IT Dev',
      description: 'イタリア向けコールセンター：イタリア語ネイティブ、CSAT 95%、3$/時間〜。ミラノ比55%削減。',
      heroTitle: 'イタリア向けコールセンター — イタリア語ネイティブサポート',
      heroSubtitle: 'ニアショア価格でプレミアムなイタリア語体験。',
    },
    ko: {
      title: '이탈리아 콜센터 | 이탈리아어 고객 서비스 | Call IT Dev',
      description: '이탈리아 콜센터: 이탈리아어 원어민, CSAT 95%, 3$/시간부터. 밀라노 대비 55% 절감.',
      heroTitle: '이탈리아 콜센터 — 이탈리아어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 이탈리아어 체험.',
    },
    ru: {
      title: 'Колл-центр Италия | Итальяноязычный сервис | Call IT Dev',
      description: 'Колл-центр для Италии: итальяноговорящие агенты, CSAT 95%, от 3 $/ч. Экономия 55% vs Милан.',
      heroTitle: 'Колл-центр для Италии — Итальяноязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание на итальянском. На 55% дешевле Милана.',
    },
  },

  // ============ PORTUGAL — expand from 2 to 15 languages ============
  portugal: {
    es: {
      title: 'Call Center Portugal | Atención al Cliente en Portugués | Call IT Dev',
      description: 'Call center para Portugal: agentes lusófonos, CSAT 95%, desde 3 $/h. 50% ahorro vs Lisboa.',
      heroTitle: 'Call Center para Portugal — Soporte Lusófono',
      heroSubtitle: 'Atención al cliente premium en portugués. 50% más barato que Lisboa.',
    },
    de: {
      title: 'Call Center Portugal | Portugiesischsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Portugal: portugiesische Muttersprachler, CSAT 95%, ab 3 $/h. 50% Ersparnis vs Lissabon.',
      heroTitle: 'Call Center für Portugal — Portugiesischsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice auf Portugiesisch. 50% günstiger als Lissabon.',
    },
    ar: {
      title: 'مركز اتصال البرتغال | خدمة عملاء بالبرتغالية | Call IT Dev',
      description: 'مركز اتصال للبرتغال: وكلاء ناطقون بالبرتغالية، CSAT 95%، من 3 $/ساعة. توفير 50% مقارنة بلشبونة.',
      heroTitle: 'مركز اتصال للبرتغال — دعم بالبرتغالية',
      heroSubtitle: 'خدمة عملاء متميزة بالبرتغالية. أقل 50% من لشبونة.',
    },
    it: {
      title: 'Call Center Portogallo | Assistenza in Portoghese | Call IT Dev',
      description: 'Call center per il Portogallo: agenti lusofoni, CSAT 95%, da 3 $/h. 50% risparmio vs Lisbona.',
      heroTitle: 'Call Center per il Portogallo — Supporto Lusofono',
      heroSubtitle: 'Assistenza premium in portoghese. 50% in meno rispetto a Lisbona.',
    },
    nl: {
      title: 'Callcenter Portugal | Portugeestalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Portugal: Portugeestalige agenten, CSAT 95%, vanaf 3 $/u. 50% besparing vs Lissabon.',
      heroTitle: 'Callcenter voor Portugal — Portugeestalige Support',
      heroSubtitle: 'Premium klantenservice in het Portugees. 50% goedkoper dan Lissabon.',
    },
    pl: {
      title: 'Call Center Portugalia | Obsługa po Portugalsku | Call IT Dev',
      description: 'Call center dla Portugalii: portugalskojęzyczni agenci, CSAT 95%, od 3 $/h. 50% oszczędności vs Lizbona.',
      heroTitle: 'Call Center dla Portugalii — Portugalskojęzyczna Obsługa',
      heroSubtitle: 'Premiumowa obsługa po portugalsku. 50% taniej niż Lizbona.',
    },
    tr: {
      title: 'Portekiz Çağrı Merkezi | Portekizce Müşteri Hizmetleri | Call IT Dev',
      description: 'Portekiz için çağrı merkezi: Portekizce konuşan ajanlar, CSAT %95, 3 $/saatten. Lizbon\'a göre %50 tasarruf.',
      heroTitle: 'Portekiz İçin Çağrı Merkezi — Portekizce Destek',
      heroSubtitle: 'Nearshore fiyatlarla Portekizce premium müşteri hizmeti.',
    },
    sv: {
      title: 'Callcenter Portugal | Portugisiskspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Portugal: portugisiskspråkiga agenter, CSAT 95%, från 3 $/h. 50% besparing vs Lissabon.',
      heroTitle: 'Callcenter för Portugal — Portugisiskspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst på portugisiska. 50% billigare än Lissabon.',
    },
    da: {
      title: 'Callcenter Portugal | Portugisisksproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Portugal: portugisisksproget agenter, CSAT 95%, fra 3 $/t. 50% besparelse vs Lissabon.',
      heroTitle: 'Callcenter for Portugal — Portugisisksproget Kundeservice',
      heroSubtitle: 'Premium kundeservice på portugisisk. 50% billigere end Lissabon.',
    },
    zh: {
      title: '葡萄牙呼叫中心 | 葡萄牙语客服外包 | Call IT Dev',
      description: '葡萄牙呼叫中心外包：葡语母语座席，CSAT 95%，3美元/小时起。比里斯本节省50%。',
      heroTitle: '葡萄牙呼叫中心 — 葡语母语支持',
      heroSubtitle: '以nearshore价格提供优质葡萄牙语客户体验。',
    },
    ja: {
      title: 'ポルトガルコールセンター | ポルトガル語サポート | Call IT Dev',
      description: 'ポルトガル向けコールセンター：ポルトガル語ネイティブ、CSAT 95%、3$/時間〜。リスボン比50%削減。',
      heroTitle: 'ポルトガル向けコールセンター — ポルトガル語サポート',
      heroSubtitle: 'ニアショア価格でプレミアムなポルトガル語体験。',
    },
    ko: {
      title: '포르투갈 콜센터 | 포르투갈어 고객 서비스 | Call IT Dev',
      description: '포르투갈 콜센터: 포르투갈어 원어민, CSAT 95%, 3$/시간부터. 리스본 대비 50% 절감.',
      heroTitle: '포르투갈 콜센터 — 포르투갈어 원어민 지원',
      heroSubtitle: '니어쇼어 가격으로 프리미엄 포르투갈어 체험.',
    },
    ru: {
      title: 'Колл-центр Португалия | Португалоязычный сервис | Call IT Dev',
      description: 'Колл-центр для Португалии: португалоговорящие агенты, CSAT 95%, от 3 $/ч. Экономия 50% vs Лиссабон.',
      heroTitle: 'Колл-центр для Португалии — Португалоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание на португальском. На 50% дешевле Лиссабона.',
    },
  },

  // ============ NETHERLANDS — expand from 2 to 15 languages ============
  netherlands: {
    es: {
      title: 'Call Center Países Bajos | Atención Multilingüe | Call IT Dev',
      description: 'Call center para Países Bajos: agentes multilingües, CSAT 95%, desde 3 $/h. 55% ahorro vs Ámsterdam.',
      heroTitle: 'Call Center para Países Bajos — Soporte Multilingüe',
      heroSubtitle: 'Atención al cliente premium para el mercado neerlandés.',
    },
    de: {
      title: 'Callcenter Niederlande | Mehrsprachiger Kundenservice | Call IT Dev',
      description: 'Callcenter für Niederlande: mehrsprachige Agenten, CSAT 95%, ab 3 $/h. 55% Ersparnis vs Amsterdam.',
      heroTitle: 'Callcenter für die Niederlande — Mehrsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den niederländischen Markt.',
    },
    ar: {
      title: 'مركز اتصال هولندا | خدمة عملاء متعددة اللغات | Call IT Dev',
      description: 'مركز اتصال لهولندا: وكلاء متعددو اللغات، CSAT 95%، من 3 $/ساعة. توفير 55% مقارنة بأمستردام.',
      heroTitle: 'مركز اتصال لهولندا — دعم متعدد اللغات',
      heroSubtitle: 'خدمة عملاء متميزة للسوق الهولندي.',
    },
    it: {
      title: 'Call Center Paesi Bassi | Assistenza Multilingue | Call IT Dev',
      description: 'Call center per i Paesi Bassi: agenti multilingui, CSAT 95%, da 3 $/h. 55% risparmio vs Amsterdam.',
      heroTitle: 'Call Center per i Paesi Bassi — Supporto Multilingue',
      heroSubtitle: 'Assistenza premium per il mercato olandese.',
    },
    pt: {
      title: 'Call Center Países Baixos | Atendimento Multilingue | Call IT Dev',
      description: 'Call center para Países Baixos: agentes multilingues, CSAT 95%, a partir de 3 $/h. 55% economia vs Amsterdã.',
      heroTitle: 'Call Center para Países Baixos — Suporte Multilingue',
      heroSubtitle: 'Atendimento premium para o mercado holandês.',
    },
    pl: {
      title: 'Call Center Holandia | Wielojęzyczna Obsługa Klienta | Call IT Dev',
      description: 'Call center dla Holandii: wielojęzyczni agenci, CSAT 95%, od 3 $/h. 55% oszczędności vs Amsterdam.',
      heroTitle: 'Call Center dla Holandii — Wielojęzyczne Wsparcie',
      heroSubtitle: 'Premiumowa obsługa klienta dla rynku holenderskiego.',
    },
    tr: {
      title: 'Hollanda Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Hollanda için çağrı merkezi: çok dilli ajanlar, CSAT %95, 3 $/saatten. Amsterdam\'a göre %55 tasarruf.',
      heroTitle: 'Hollanda İçin Çağrı Merkezi — Çok Dilli Destek',
      heroSubtitle: 'Hollanda pazarı için premium müşteri hizmeti.',
    },
    sv: {
      title: 'Callcenter Nederländerna | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Nederländerna: flerspråkiga agenter, CSAT 95%, från 3 $/h. 55% besparing vs Amsterdam.',
      heroTitle: 'Callcenter för Nederländerna — Flerspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för den nederländska marknaden.',
    },
    da: {
      title: 'Callcenter Holland | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Holland: flersproget agenter, CSAT 95%, fra 3 $/t. 55% besparelse vs Amsterdam.',
      heroTitle: 'Callcenter for Holland — Flersproget Kundeservice',
      heroSubtitle: 'Premium kundeservice for det hollandske marked.',
    },
    zh: {
      title: '荷兰呼叫中心 | 多语言客服外包 | Call IT Dev',
      description: '荷兰呼叫中心外包：多语言座席，CSAT 95%，3美元/小时起。比阿姆斯特丹节省55%。',
      heroTitle: '荷兰呼叫中心 — 多语言支持',
      heroSubtitle: '为荷兰市场提供优质多语言客户服务。',
    },
    ja: {
      title: 'オランダコールセンター | 多言語カスタマーサポート | Call IT Dev',
      description: 'オランダ向けコールセンター：多言語対応、CSAT 95%、3$/時間〜。アムステルダム比55%削減。',
      heroTitle: 'オランダ向けコールセンター — 多言語サポート',
      heroSubtitle: 'オランダ市場向けプレミアムカスタマーサービス。',
    },
    ko: {
      title: '네덜란드 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '네덜란드 콜센터: 다국어 상담원, CSAT 95%, 3$/시간부터. 암스테르담 대비 55% 절감.',
      heroTitle: '네덜란드 콜센터 — 다국어 고객 지원',
      heroSubtitle: '네덜란드 시장을 위한 프리미엄 다국어 서비스.',
    },
    ru: {
      title: 'Колл-центр Нидерланды | Многоязычный сервис | Call IT Dev',
      description: 'Колл-центр для Нидерландов: многоязычные агенты, CSAT 95%, от 3 $/ч. Экономия 55% vs Амстердам.',
      heroTitle: 'Колл-центр для Нидерландов — Многоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для голландского рынка.',
    },
  },

  // ============ QATAR — expand from 2 to 15 languages ============
  qatar: {
    es: {
      title: 'Call Center Qatar | Servicio al Cliente Multilingüe | Call IT Dev',
      description: 'Call center para Qatar: agentes árabe e inglés, CSAT 95%, desde 3 $/h. Soporte 24/7.',
      heroTitle: 'Call Center para Qatar — Soporte Multilingüe',
      heroSubtitle: 'Atención al cliente premium para el mercado qatarí.',
    },
    de: {
      title: 'Call Center Katar | Mehrsprachiger Kundenservice | Call IT Dev',
      description: 'Call Center für Katar: arabisch- und englischsprachige Agenten, CSAT 95%, ab 3 $/h.',
      heroTitle: 'Call Center für Katar — Mehrsprachiger Support',
      heroSubtitle: 'Premium-Kundenservice für den katarischen Markt.',
    },
    it: {
      title: 'Call Center Qatar | Assistenza Multilingue | Call IT Dev',
      description: 'Call center per il Qatar: agenti arabofoni e anglofoni, CSAT 95%, da 3 $/h. Supporto 24/7.',
      heroTitle: 'Call Center per il Qatar — Supporto Multilingue',
      heroSubtitle: 'Assistenza premium per il mercato qatariota.',
    },
    pt: {
      title: 'Call Center Catar | Atendimento Multilingue | Call IT Dev',
      description: 'Call center para Catar: agentes árabe e inglês, CSAT 95%, a partir de 3 $/h. Suporte 24/7.',
      heroTitle: 'Call Center para Catar — Suporte Multilingue',
      heroSubtitle: 'Atendimento premium para o mercado catariano.',
    },
    nl: {
      title: 'Callcenter Qatar | Meertalige Klantenservice | Call IT Dev',
      description: 'Callcenter voor Qatar: Arabisch- en Engelstalige agenten, CSAT 95%, vanaf 3 $/u.',
      heroTitle: 'Callcenter voor Qatar — Meertalige Support',
      heroSubtitle: 'Premium klantenservice voor de Qatarese markt.',
    },
    pl: {
      title: 'Call Center Katar | Wielojęzyczna Obsługa Klienta | Call IT Dev',
      description: 'Call center dla Kataru: agenci arabsko- i anglojęzyczni, CSAT 95%, od 3 $/h.',
      heroTitle: 'Call Center dla Kataru — Wielojęzyczne Wsparcie',
      heroSubtitle: 'Premiumowa obsługa klienta dla rynku katarskiego.',
    },
    tr: {
      title: 'Katar Çağrı Merkezi | Çok Dilli Müşteri Hizmetleri | Call IT Dev',
      description: 'Katar için çağrı merkezi: Arapça ve İngilizce konuşan ajanlar, CSAT %95, 3 $/saatten.',
      heroTitle: 'Katar İçin Çağrı Merkezi — Çok Dilli Destek',
      heroSubtitle: 'Katar pazarı için premium müşteri hizmeti.',
    },
    sv: {
      title: 'Callcenter Qatar | Flerspråkig Kundtjänst | Call IT Dev',
      description: 'Callcenter för Qatar: arabisk- och engelskspråkiga agenter, CSAT 95%, från 3 $/h.',
      heroTitle: 'Callcenter för Qatar — Flerspråkig Kundtjänst',
      heroSubtitle: 'Premium kundtjänst för den qatariska marknaden.',
    },
    da: {
      title: 'Callcenter Qatar | Flersproget Kundeservice | Call IT Dev',
      description: 'Callcenter for Qatar: arabisk- og engelsksproget agenter, CSAT 95%, fra 3 $/t.',
      heroTitle: 'Callcenter for Qatar — Flersproget Kundeservice',
      heroSubtitle: 'Premium kundeservice for det qatariske marked.',
    },
    zh: {
      title: '卡塔尔呼叫中心 | 多语言客服 | Call IT Dev',
      description: '卡塔尔呼叫中心：阿拉伯语和英语座席，CSAT 95%，3美元/小时起。24/7支持。',
      heroTitle: '卡塔尔呼叫中心 — 多语言支持',
      heroSubtitle: '为卡塔尔市场提供优质多语言客户服务。',
    },
    ja: {
      title: 'カタールコールセンター | 多言語サポート | Call IT Dev',
      description: 'カタール向けコールセンター：アラビア語・英語対応、CSAT 95%、3$/時間〜。',
      heroTitle: 'カタール向けコールセンター — 多言語サポート',
      heroSubtitle: 'カタール市場向けプレミアムカスタマーサービス。',
    },
    ko: {
      title: '카타르 콜센터 | 다국어 고객 서비스 | Call IT Dev',
      description: '카타르 콜센터: 아랍어·영어 상담원, CSAT 95%, 시간당 3달러부터. 24/7 지원.',
      heroTitle: '카타르 콜센터 — 다국어 고객 지원',
      heroSubtitle: '카타르 시장을 위한 프리미엄 다국어 서비스.',
    },
    ru: {
      title: 'Колл-центр Катар | Многоязычный сервис | Call IT Dev',
      description: 'Колл-центр для Катара: арабо- и англоязычные агенты, CSAT 95%, от 3 $/ч.',
      heroTitle: 'Колл-центр для Катара — Многоязычная поддержка',
      heroSubtitle: 'Премиум-обслуживание для катарского рынка.',
    },
  },
};
